import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, ShieldAlert, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import { api, dataIt, formatError } from "@/lib/api";

export const PrivacyBadge = ({ c }) => (c.privacy_firmata
  ? <span className="inline-flex items-center gap-1 rounded-sm bg-emerald-50 px-1.5 py-0.5 text-[11px] font-bold text-emerald-700 ring-1 ring-emerald-200" data-testid={`privacy-badge-${c.id}`}><ShieldCheck className="h-3 w-3" /> Firmata</span>
  : <span className="inline-flex items-center gap-1 rounded-sm bg-rose-50 px-1.5 py-0.5 text-[11px] font-bold text-rose-700 ring-1 ring-rose-200" data-testid={`privacy-badge-${c.id}`}><ShieldAlert className="h-3 w-3" /> Da firmare</span>);

export const PrivacyCard = ({ c, onChange }) => {
  const navigate = useNavigate();
  const [marketing, setMarketing] = useState(!!c.consenso_marketing);
  const salva = async (firmata) => {
    try {
      await api.post(`/clienti/${c.id}/privacy`, { firmata, marketing });
      toast.success(firmata ? "Privacy registrata come firmata" : "Firma privacy annullata");
      onChange();
    } catch (e) {
      toast.error(formatError(e));
    }
  };

  return (
    <div className="space-y-3 rounded-lg border border-slate-200 bg-white p-5 text-sm shadow-sm" data-testid="privacy-card">
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Privacy (GDPR)</p>
        <PrivacyBadge c={c} />
      </div>
      {c.privacy_firmata ? (
        <p className="text-slate-600" data-testid="privacy-stato">Firmata il <b>{dataIt(c.privacy_data?.slice(0, 10))}</b> · Promozioni: <b>{c.consenso_marketing ? "consenso dato" : "consenso negato"}</b></p>
      ) : (
        <p className="text-slate-600" data-testid="privacy-stato">Il cliente non ha ancora firmato l'informativa privacy.</p>
      )}
      <Button variant="outline" className="w-full" onClick={() => navigate(`/clienti/${c.id}/privacy`)} data-testid="privacy-stampa-button"><Printer className="mr-1 h-4 w-4" /> Stampa modulo privacy</Button>
      {!c.privacy_firmata && (
        <label className="flex items-center gap-2 text-xs text-slate-600">
          <Checkbox checked={marketing} onCheckedChange={(v) => setMarketing(!!v)} data-testid="privacy-marketing-checkbox" />
          Ha dato il consenso alle comunicazioni promozionali
        </label>
      )}
      {c.privacy_firmata
        ? <Button variant="ghost" size="sm" className="w-full text-slate-500" onClick={() => salva(false)} data-testid="privacy-annulla-button">Annulla firma</Button>
        : <Button className="w-full bg-orange-600 hover:bg-orange-700" onClick={() => salva(true)} data-testid="privacy-firmata-button"><ShieldCheck className="mr-1 h-4 w-4" /> Segna come firmata</Button>}
    </div>
  );
};
